import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getMessaging } from 'firebase/messaging';
import { getAnalytics } from "firebase/analytics"; // <-- NEW: Analytics Import

const firebaseConfig = {
  apiKey: "AIzaSyD94C-Y7-OwOv-eONgwGu63jiumhWW9OG8",
  authDomain: "nundinaria.firebaseapp.com",
  projectId: "nundinaria",
  storageBucket: "nundinaria.firebasestorage.app",
  messagingSenderId: "593965132972",
  appId: "1:593965132972:web:6e96b776dad62f3945c309",
  measurementId: "G-5ECDLSHLMN"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const messaging = getMessaging(app);
export const analytics = getAnalytics(app); // <-- NEW: Analytics Export